import { Typography } from "@material-ui/core";
import { LocalizerHelper } from "../../helpers/localizerHelper";
import { DeliveryDetails } from "../../models/session";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

interface Props{
}

export const DeliveryDetailsView = () => {
  const deliveryDetails = useSelector((state: RootState) => state.session.session?.delivery_details);

  if(!deliveryDetails) return null;
  return (
    <div className="container" style={{marginBottom: 20}}>
      <div className="row">
        <div className="col-md-12 text-left">
            <Typography variant="h4" gutterBottom align="left" className="recap-header">
              {LocalizerHelper.localized('delivery_details')}
            </Typography>
        </div>
      </div>
      <div className="row">
        {deliveryDetails.address &&
        <div className="col-md-12 text-left">
          <span className="delivery-details-label">{LocalizerHelper.localized('address')}</span> 
          {deliveryDetails.address}
        </div>}
        {deliveryDetails.doorbell_name &&
        <div className="col-md-12 text-left">
          <span className="delivery-details-label">{LocalizerHelper.localized('doorbell_name')}</span> 
          {deliveryDetails.doorbell_name}
        </div>}
        {deliveryDetails.phone_number &&
        <div className="col-md-12 text-left">
          <span className="delivery-details-label">{LocalizerHelper.localized('phone_number')}</span> 
          {deliveryDetails.phone_number}
        </div>}
        {deliveryDetails.notes &&
        <div className="col-md-12 text-left">
            <span className="delivery-details-label">{LocalizerHelper.localized('notes')}</span> 
            {deliveryDetails.notes}
        </div>}
      </div>
    </div>
  );
};
